import React, { useContext } from "react";
import { RegistrationFormContext } from "./types";
import { InputCheckbox } from "../../../../HtmlComponents/InputCheckbox";
import { TextAreaElement } from "../../../../HtmlComponents/TextAreaElement";

const Section13 = () => {
  const {
    criminalCivilConvictions, setCriminalCivilConvictions,
    judicialDisciplinaryActions, setJudicialDisciplinaryActions,
  } = useContext(RegistrationFormContext);

  return (<>
    <div>
      <p className='font-bold text-main'>{"47) "}Avez-vous encouru des condamnations pénales où civiles: </p>
      <InputCheckbox 
        name="Oui"
        id="criminalCivilConvictions" 
        checked={criminalCivilConvictions === "Oui"} 
        value={criminalCivilConvictions}
        setValue={setCriminalCivilConvictions}
      />
      {(criminalCivilConvictions || typeof criminalCivilConvictions === "string") && <TextAreaElement textAreaClass='md:w-1/2' name='Laquelle?' value={criminalCivilConvictions} setValue={setCriminalCivilConvictions}/>}
    </div>

    <div>
      <p className='font-bold text-main'>{"48) "}Une poursuite judiciaire ou disciplinaire est-elle actuellement en cours à votre égard: </p>
      <InputCheckbox 
        name="Oui"
        id="judicialDisciplinaryActions" 
        checked={judicialDisciplinaryActions === "Oui"} 
        value={judicialDisciplinaryActions} 
        setValue={setJudicialDisciplinaryActions}
      />
      {(judicialDisciplinaryActions || typeof judicialDisciplinaryActions === "string") && <TextAreaElement textAreaClass='md:w-1/2' name='Laquelle?' value={judicialDisciplinaryActions} setValue={setJudicialDisciplinaryActions}/>}
    </div>
  </>);
};

export default Section13;
